import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from 'antd'

import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import styles from './excuteDetailModal.module.css'
import moment from 'moment'
import {
  DateTimeFormat,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimplePrintCharge,
} from '../../../models/datetime'
import {
  CaretDownFilled,
  CloseOutlined,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { RcFile, UploadFile } from 'antd/lib/upload/interface'
import FileUpload from '../../../compnents/file/FileUpload'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  getExcuteDetailAsync,
  getExcuteDetailList,
  getLatelyOperatorList,
  getToBeCompletedTreatmentSubmit,
  updateExcuteDetailAsync,
} from './toBeCompletedTreatmentSlice'
import { getUrl } from '../../treatment/diagnosis/diagnosisSlice'
import { getGenderName, StationCategory } from '../../../models/user'
import { getUsersInDepartmentAsync } from '../../completion/completionSlice'
import { selectTenantName, selectUserId } from '../../../app/applicationSlice'
import { getAge } from '../../../utils/StringUtils'
import { defaultXianBingListAsync } from '../../treatment/tcmCases/tcmCasesSlice'
import { SettingTreatmentParts } from '../../examinetreat/settingTreatmentParts'
import {
  getTreatmentPartsName,
  TreatmentPartsCategoris,
} from '../../../models/setmeal'

const { Option } = Select

export const ExcuteDetailModal = (props: {
  isModalVisible: boolean
  id: any
  executeId?: any
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [fileList, setFileList] = useState<UploadFile[]>([])

  const [value, setValue] = useState<any>(0)

  const [detail, setDetail] = useState<any>()

  const [formValues, setFormValues] = useState<any>()

  const [doctorList, setDoctorList] = useState<any>([])

  const [assistantList, setAssistantList] = useState<any>([])

  const [editTreatmentParts, setEditTreatmentParts] = useState(false)

  const [treatmentPartsList, setTreatmentPartsList] = useState<any>([])

  const [treatmentParts, setTreatmentParts] = useState<string>('')

  const tenantName = useSelector(selectTenantName)

  const [checked, setChecked] = useState(false)

  const time: any = moment().format(DateTimeFormat)

  const UserId = useSelector(selectUserId)

  useEffect(() => {
    if (props.isModalVisible) {
      dispatch(
        getExcuteDetailList({
          id: props?.executeId ? props?.executeId : props?.id,
        })
      )
        .then(unwrapResult)
        .then((res: any) => {
          setDetail(res)
          if (!props?.executeId) {
            form.setFieldsValue({
              executeTime: moment(),
              operatorId: [UserId?.toString()],
              treatmentParts: res?.defaultTreatmentParts
                ? res?.defaultTreatmentParts?.split(',')
                : [],
            })
          }
        })
    }
  }, [props.isModalVisible, props?.executeId])

  useEffect(() => {
    if (props.isModalVisible)
      dispatch(
        getUsersInDepartmentAsync({
          departmentId: '',
          stationCategory: StationCategory.DoctorOrPharmacist,
        })
      )
        .then(unwrapResult)
        .then((res) => {
          setDoctorList(res)
        })

    dispatch(defaultXianBingListAsync(2))
      .then(unwrapResult)
      .then((res) => {
        setTreatmentPartsList(res)
      })
  }, [props.isModalVisible])

  useEffect(() => {
    if (doctorList) {
      dispatch(
        getUsersInDepartmentAsync({
          departmentId: '',
          // stationCategory: StationCategory.DoctorOrPharmacist,
          multyStationCategory: '0,1,7',
        })
      )
        .then(unwrapResult)
        .then((res) => {
          setAssistantList(res)
        })
    }
  }, [doctorList])

  useEffect(() => {
    if (props.isModalVisible) {
      form.setFieldsValue({
        executeNum: '',
      })
      const json =
        localStorage.getItem('medicalSationChecked') == 'true' ? true : false
      setChecked(json)
      setValue(0)
    }
  }, [props.isModalVisible])

  useEffect(() => {
    if (props.isModalVisible && props.executeId) {
      dispatch(getExcuteDetailAsync(props.id))
        .then(unwrapResult)
        .then((v: any) => {
          setFormValues(v)
          setValue(v?.executeNum)
          form.setFieldsValue({
            ...v,
            executeTime: moment(v.executeTime),
            executeEndTime: moment(v.executeEndTime),
            operatorId: v?.operatorId
              ? v?.operatorId?.split(',')?.map((v: any) => v?.toString())
              : [UserId?.toString()],
            treatmentParts: v?.treatmentParts
              ? v?.treatmentParts?.split(',')
              : [],
          })
          setFileList(
            v?.attachmentFile
              ? v?.attachmentFile.split(',').map((v: any) => {
                  return ({
                    name: v.split('@')[0],
                    uid: v.split('@')[1],
                    url: v.split('@')[2],
                  } as unknown) as UploadFile
                })
              : []
          )
        })
    }
  }, [props.executeId, props.isModalVisible])

  return (
    <Modal
      width={700}
      title={props.executeId ? '修改' : '执行'}
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <Row
        style={{
          lineHeight: '30px',
          marginBottom: '20px',
          fontSize: '14px',
        }}
      >
        <Col span={8}>患者姓名：{detail?.patientName}</Col>
        <Col span={8}>性别：{getGenderName(detail?.patientSex)}</Col>
        <Col span={8}>
          年龄：
          {detail?.patientAge}
        </Col>
        <Col span={8}>项目：{detail?.treatmentServiceName}</Col>
        <Col span={8}>就诊医生：{detail?.doctorName}</Col>
        <Col
          span={8}
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          就诊时间：
          <a
            title={
              detail?.clinicTime
                ? moment(detail?.clinicTime).format(DateTimeFormat)
                : '-'
            }
            style={{ color: '#000' }}
          >
            {detail?.clinicTime
              ? moment(detail?.clinicTime).format(DateTimeFormat)
              : '-'}
          </a>
        </Col>
      </Row>
      <Form
        className={styles.form}
        name='basic'
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 16 }}
        initialValues={{
          executeTime: moment(),
          operatorId: [UserId.toString()],
        }}
        autoComplete='off'
        onFinish={(values) => {
          if (value > detail?.remainNum && !props.executeId) {
            notification.error({
              message: '本次执行次数不能大于剩余次数，请重新输入次数',
            })
          } else if (
            value > detail?.remainNum + formValues?.executeNum &&
            props.executeId
          ) {
            notification.error({
              message: '本次执行次数不能大于剩余次数，请重新输入次数',
            })
          } else {
            // const operatorName =
            //   (assistantList.find(
            //     (u: any) => u.id === values.operatorId
            //   ) as any)?.name || ''
            const data = assistantList.filter((item: any) =>
              values.operatorId.includes(item.id)
            )

            // 2. 提取 name
            const operatorName = data.map((item: any) => item.name)

            const momentType = props?.executeId
              ? DateTimeFormat
              : DateTimeFormatSimpleOnlyOne
            const params = {
              ...values,
              executeTime: values?.executeTime
                ? moment(values?.executeTime).format(momentType)
                : moment().format(momentType),
              executeEndTime: values?.executeEndTime
                ? moment(values?.executeEndTime).format(momentType)
                : moment().format(momentType),
              operatorName: operatorName?.length
                ? operatorName?.join(',')
                : detail?.latelyOperatorName || detail?.doctorName,
              operatorId: values?.operatorId?.length
                ? values?.operatorId?.join(',')
                : '',
              attachmentFile: fileList
                ?.map((v) => `${v.name}@${v.uid}@`.concat(v.url || ''))
                .join(','),
              treatmentParts: values?.treatmentParts?.length
                ? values?.treatmentParts?.join(',')
                : '',
              id: props?.id,
              smsFlag: checked,
            }
            dispatch(
              props?.executeId
                ? updateExcuteDetailAsync(params)
                : getToBeCompletedTreatmentSubmit(params)
            )
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '执行成功',
                })
                form.resetFields()
                props?.onOk()
                setFileList([])
              })
              .catch(() => {
                // form.resetFields()
                // props?.onCancel()
                // setFileList([])
              })
          }
        }}
      >
        <Form.Item
          style={{ padding: '30px 0' }}
          label='本次执行次数：'
          name='executeNum'
          rules={[
            { required: true, message: '请填写本次执行次数' },
            {
              pattern: new RegExp(/^[0-9]\d*(\.\d)?$/),
              message: '请输入数字，支持小数点后一位',
            },
          ]}
        >
          <Input
            onChange={(e) => {
              const inputValue = e.target.value
              // const numericValue = inputValue.replace(/[^\d]/g, '')
              setValue(inputValue)
              form.setFieldsValue({ executeNum: inputValue })
            }}
          />
        </Form.Item>
        <Form.Item
          required
          name='executeTime'
          label='执行开始时间'
          rules={[{ required: true, message: '请选择本次执行开始时间' }]}
        >
          <DatePicker
            showTime
            format='YYYY/MM/DD HH:mm'
            defaultValue={moment(time, DateTimeFormat)}
            style={{
              width: '100%',
            }}
          />
        </Form.Item>
        <Form.Item name='executeEndTime' label='执行结束时间'>
          <DatePicker
            showTime
            format='YYYY/MM/DD HH:mm'
            style={{
              width: '100%',
            }}
          />
        </Form.Item>
        <Form.Item
          name='operatorId'
          label='执行人：'
          rules={[{ required: true, message: '请选择执行人' }]}
        >
          <Select
            mode='multiple'
            placeholder='执行人'
            allowClear
            // suffixIcon={<CaretDownFilled />}
          >
            {assistantList.map((v: any) => (
              <Option key={v.id} value={v.id}>
                {v.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Col span={24} style={{ position: 'relative' }}>
          <Form.Item name='treatmentParts' label='治疗部位'>
            <Select
              mode='multiple'
              allowClear
              value={treatmentParts}
              onChange={(value: any) => {
                setTreatmentParts(value)
              }}
            >
              {TreatmentPartsCategoris?.map((v) => {
                return (
                  <Option key={v} value={getTreatmentPartsName(v)}>
                    {getTreatmentPartsName(v)}
                  </Option>
                )
              })}
              {treatmentPartsList.map((v: any) => {
                return (
                  <Option key={v.id} value={v.name}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <div style={{ position: 'absolute', top: '5px', right: '116px' }}>
            <SettingOutlined
              style={{ color: '#999999' }}
              onClick={() => setEditTreatmentParts(true)}
            />
          </div>
        </Col>
        <Form.Item name='remark' label='备注'>
          <Input.TextArea />
        </Form.Item>
        <Form.Item name='attachmentFile' label='附件'>
          <FileUpload
            count={(fileList && fileList.length) || 0}
            files={fileList}
            onUpload={(v, i) => {
              setFileList([
                ...fileList,
                {
                  uid: v.uid,
                  size: v.size,
                  name: v.name,
                  type: v.type,
                  originFileObj: {} as RcFile,
                  url: i,
                },
              ])
            }}
          >
            <Button icon={<PlusOutlined />}>上传附件</Button>
          </FileUpload>
          {fileList &&
            fileList.map((item) => (
              <Row
                gutter={24}
                key={item.uid}
                style={{
                  padding: '10px',
                  width: '300px',
                }}
              >
                <Col flex={1}>
                  <span
                    style={{
                      display: 'inline-block',
                      maxWidth: '60px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      verticalAlign: 'middle',
                    }}
                  >
                    {item.name.split('.')[0]}
                  </span>
                  <span
                    style={{
                      verticalAlign: 'middle',
                    }}
                  >
                    .{item.name.split('.')[1]}
                  </span>
                </Col>
                <Col span={6}>
                  <a
                    onClick={() => {
                      dispatch(getUrl({ fileName: item.url }))
                        .then(unwrapResult)
                        .then((v: any) => {
                          const proxy =
                            window.location.origin.indexOf(
                              'his.develop.hydhis.com'
                            ) >= 0
                              ? '/proxyToOssDevPrivate'
                              : window.location.origin.indexOf(
                                  'his.test.hydhis.com'
                                ) >= 0
                              ? '/proxyToOssTestPrivate'
                              : window.location.origin.indexOf('hydhis.cn') >= 0
                              ? '/proxyToOssProdPrivate'
                              : '/proxyToOssProdPrivate'
                          const url =
                            (window.location.origin?.includes('localhost')
                              ? 'http://his.develop.hydhis.com'
                              : window.location.origin) +
                            proxy +
                            v
                          window.open(url, '_blank')
                        })
                    }}
                  >
                    查看
                  </a>
                </Col>
                <Col span={6}>
                  <CloseOutlined
                    onClick={() => {
                      //  e.stopPropagation();
                      setFileList(() =>
                        fileList.filter((ite) => ite.uid !== item.uid)
                      )
                    }}
                  />
                </Col>
              </Row>
            ))}
        </Form.Item>
        <div style={{ paddingLeft: '10px', marginBottom: '10px' }}>
          <Checkbox
            checked={checked}
            onChange={() => {
              setChecked(!checked)
              localStorage.setItem(
                'medicalSationChecked',
                JSON.stringify(!checked)
              )
            }}
          >
            发送短信 {tenantName?.split('-')?.[0]} 温馨提示：您所办理的
            {detail?.treatmentServiceName}疗程，完成{value || '-'}次调理，剩余
            {props.executeId
              ? Number(
                  detail?.remainNum +
                    formValues?.executeNum -
                    Number(value || 0)
                )?.toFixed(1)
              : Number(detail?.remainNum - Number(value || 0))?.toFixed(1)}
            次。
          </Checkbox>
          {/* {sureData?.smsSendFlg == 1 ? (<p>该预约已发送过短信</p>) : ''} */}
        </div>
        <Row gutter={20}>
          <Col span={24}>
            <Button type='primary' htmlType='submit' style={{ float: 'right' }}>
              确认
            </Button>
          </Col>
        </Row>
      </Form>
      <SettingTreatmentParts
        isSettingTreatmentParts={editTreatmentParts}
        onCancel={() => {
          setEditTreatmentParts(false)
        }}
        onOk={() => {
          setEditTreatmentParts(false)
        }}
        refresh={() => {
          dispatch(defaultXianBingListAsync(2))
            .then(unwrapResult)
            .then((res) => {
              setTreatmentPartsList(res)
            })
        }}
      />
    </Modal>
  )
}
